import React, { Component } from "react";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import TextField from "@material-ui/core/TextField";
import { Trans, withTranslation } from "react-i18next";
import { connect } from "react-redux";
import Typography from "@material-ui/core/Typography";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import SwipeableViews from "react-swipeable-views";
import ReportingStepDataSource from "../chart-steps/ReportingStepDataSource";
import ChartStepTwo from "../chart-steps/ChartStepTwo";
import ChartStepThree from "../chart-steps/ChartStepThree";
import ChartStepFour from "../chart-steps/ChartStepFour";
import { getChartData } from "../util/ChartUtils";
import DialogActions from "@material-ui/core/DialogActions";
import Stepper from "@material-ui/core/Stepper";
import Step from "@material-ui/core/Step";
import Button from "@material-ui/core/Button";
import StepLabel from "@material-ui/core/StepLabel";
import ArcHash from "arc-hash";
import Dialog from "@material-ui/core/Dialog";

const styles = (theme) => ({
  sectionsType: {
    marginTop: 13,
    minWidth: 182,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  title: {
    marginBottom: theme.spacing(2),
  },
});
export class ChartGeneratorDialog extends Component {
  state = {
    activeStep: 0,
    nextDisabled: true,
    submitDisabled: true,
    chart: {
      chartType: "BarChart",
      height: 500,
      width: 600,
      xAxisTitle: "",
      yAxisTitle: "",
      yAxisTitlePosition: "insideLeft",
      xAxisTitlePosition: "insideBottom",
      series: [],
      dataUrl: "",
      dataFilters: [],
      dataBreadcrumbs: [],
      data: [],
      legend: false,
      patterns: false,
      legendLabel: "",
      legendPosition: "top",
      color: { r: 0, g: 0, b: 0, a: 0.1 },
      legendAlign: "center",
      query: "",
    },
    token: null,
    authentication: {
      requestTokenMethod: "Parameters",
      authMethod: "None",
      type: "Document",
      query: "Favourites",
      radioChoice: "Internal",
      oAuthFilters: [],
      oAuthTokenFilters: [],
      authentication: "",
      radioDataSendMethodChange: "Parameters",
      oAuthURL: "",
      oAuthIdName: "client_id",
      oAuthId: "",
      redirectParamName: "redirect_uri",
      token: "",
      // respondTokenName: "access_token",
      apiKeyMethod: "Parameter",
      apiKeyParamName: "apikey",
      apiKeyValue: "",
      username: "",
      password: "",
      state: null,
      codeVerifier: null,
      codeChallenge: null,
    },
    data: null,
    array: [],
    originalData: null,
    keys: [],
    usedKeys: [],
    groupByKey: "none",
    includeSummary: true,
    includeSummaryChart: true,
    availableStep: 0,
  };

  componentDidUpdate(prevProps) {
    if (prevProps.edit !== this.props.edit && this.props.edit) {
      let chartObject = JSON.parse(
        window.atob(this.props.chart.getAttribute("data-chart"))
      );
      this.setState({
        chart: chartObject.chart,
        authentication: chartObject.authentication,
        activeStep: 1,
      });
    }
  }

  handleAddFilter = (name) => (filter) => {
    let filters = this.state.authentication[name].splice(0);
    filters = [...filters, filter];
    this.setState({
      authentication: { ...this.state.authentication, [name]: filters },
    });
  };
  handleTextFieldChangeAuthentication = (name) => (event) => {
    if (event.target.value.trim().length > 0) {
      this.setState({
        authentication: {
          ...this.state.authentication,
          [name]: event.target.value,
        },
      });
    } else {
      let newFilter = { ...this.state.authentication };
      delete newFilter[name];
      this.setState({
        authentication: {
          ...newFilter,
        },
      });
    }
  };

  handleColourChange = (name, index) => (color) => {
    let series = [...this.state.chart.series];
    series[index][name] = color.hex;
    let chart = { ...this.state.chart, series };
    this.setState({ chart });
  };
  handeSliderChange = (name, index) => (event, newValue) => {
    let series = [...this.state.chart.series];
    series[index][name] = newValue;
    let chart = { ...this.state.chart, series };
    this.setState({ chart });
  };
  handleDeleteTokenFilter = (index) => {
    let newFilters = JSON.parse(
      JSON.stringify(this.state.authentication.oAuthTokenFilters)
    );
    newFilters.splice(index, 1);
    this.setState({
      authentication: {
        ...this.state.authentication,
        oAuthTokenFilters: newFilters,
      },
    });
  };
  handleDeleteFilter = (index) => {
    let newFilters = JSON.parse(
      JSON.stringify(this.state.authentication.oAuthFilters)
    );
    newFilters.splice(index, 1);
    this.setState({
      authentication: {
        ...this.state.authentication,
        oAuthFilters: newFilters,
      },
    });
  };
  editSeries = (index, editedChart) => {
    let chart = { ...this.state.chart };
    chart.series[index] = editedChart;
    this.setState({ chart });
  };
  handleDeleteSeries = (index) => {
    let series = [...this.state.chart.series];
    series.splice(index, 1);
    this.setState({ chart: { ...this.state.chart, series: series } });
  };
  render() {
    let { classes } = this.props;
    return (
      <Dialog
        open={this.props.open}
        onClose={this.props.onClose}
        PaperProps={{ style: { overflow: "inherit" } }}
        maxWidth="xl"
        fullWidth
        style={{ zIndex: 1305 }}
      >
        <DialogTitle>
          <Trans i18nKey="slate_create_chart" />
        </DialogTitle>
        <DialogContent
          style={{
            minWidth: 500,
            display: "flex",
            flexDirection: "column",
            flex: 1,
          }}
        >
          <Stepper activeStep={this.state.activeStep}>
            <Step completed={this.state.activeStep > 0}>
              <StepLabel>
                <Trans i18nKey="reporting_step_data_source" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 1}>
              <StepLabel>
                <Trans i18nKey="reporting_step_graph_setup" />
              </StepLabel>
            </Step>
            <Step completed={this.state.activeStep > 2}>
              <StepLabel
                optional={
                  <Typography variant="caption">
                    <Trans i18nKey="global_optional" />
                  </Typography>
                }
              >
                <Trans i18nKey="reporting_step_graph_styling" />
              </StepLabel>
            </Step>
          </Stepper>
          <SwipeableViews index={this.state.activeStep} id="templatePages">
            {this.state.activeStep === 0 && (
              <ReportingStepDataSource
                handleAuthenticationChange={this.handleAuthenticationChange}
                chart={this.state.chart}
                edit={this.props.edit}
                handleChartChange={this.handleChartChange}
                changeAvailableStep={this.changeAvailableStep}
                array={this.state.array}
                handleArrayChange={this.handleArrayChange}
                originalData={this.state.originalData}
                handleOriginalDataChange={this.handleOriginalDataChange}
                handleDataChange={this.handleDataChange}
                data={this.state.data}
                keys={this.state.keys}
                handleKeyChange={this.handleKeyChange}
                authentication={this.state.authentication}
                token={this.state.token}
                handleNext={this.handleNext}
              />
            )}
            {this.state.activeStep === 1 && (
              <ChartStepThree
                changeAvailableStep={this.changeAvailableStep}
                editSeries={this.editSeries}
                handleDeleteSeries={this.handleDeleteSeries}
                edit={this.props.edit}
                array={this.state.array}
                originalData={this.state.originalData}
                data={this.state.data}
                chart={this.state.chart}
                setUsedKeys={this.setUsedKeys}
                handleChartChange={this.handleChartChange}
                usedKeys={this.state.usedKeys}
                keys={this.state.keys}
                setNextDisabled={(nextDisabled) =>
                  this.setState({ nextDisabled })
                }
                changedUsedKey={this.changedUsedKey}
                groupByKey={this.state.groupByKey}
                setGroupByKey={this.setGroupByKey}
                includeSummary={this.state.includeSummary}
                setIncludeSummary={this.setIncludeSummary}
                includeSummaryChart={this.state.includeSummaryChart}
                setIncludeSummaryChart={this.setIncludeSummaryChart}
              />
            )}
            {this.state.activeStep === 2 && (
              <ChartStepFour
                handeSliderChange={this.handeSliderChange}
                edit={this.props.edit}
                handleColourChange={this.handleColourChange}
                handleChartChange={this.handleChartChange}
                data={this.state.data}
                chart={this.state.chart}
                setUsedKeys={this.setUsedKeys}
                usedKeys={this.state.usedKeys}
                keys={this.state.keys}
                changedUsedKey={this.changedUsedKey}
                groupByKey={this.state.groupByKey}
                setGroupByKey={this.setGroupByKey}
                includeSummary={this.state.includeSummary}
                setIncludeSummary={this.setIncludeSummary}
                includeSummaryChart={this.state.includeSummaryChart}
                setIncludeSummaryChart={this.setIncludeSummaryChart}
              />
            )}
          </SwipeableViews>
        </DialogContent>
        <DialogActions>
          {this.state.activeStep > 0 &&
            !this.props.edit && (
              <Button
                onClick={this.handleBack}
                color="primary"
                autoFocus
                id="chart-back"
              >
                <Trans i18nKey="global_back" />
              </Button>
            )}
          {this.state.activeStep === 1 &&
            this.state.chart.chartType !== "Table" && (
              <Button
                onClick={this.handleNext}
                disabled={this.state.nextDisabled}
                color="primary"
                id="chart-next"
                autoFocus
              >
                <Trans i18nKey="global_next" />
              </Button>
            )}
        </DialogActions>

        <DialogActions>
          <Button
            onClick={this.props.onClose}
            color="primary"
            id="chart-cancel"
          >
            {this.props.t("global_cancel")}
          </Button>
          <Button
            onClick={this.onSubmit}
            color="primary"
            disabled={this.state.submitDisabled}
            id="chart-submit"
          >
            {this.props.t("global_submit")}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
  generateState = () => {
    const validChars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let array = new Uint8Array(60);
    window.crypto.getRandomValues(array);
    array = array.map((x) => validChars.charCodeAt(x % validChars.length));
    return String.fromCharCode.apply(null, array);
  };
  componentDidMount() {
    if (this.props.edit) {
      let chartObject = JSON.parse(
        window.atob(this.props.chart.getAttribute("data-chart"))
      );
      this.setState(
        {
          chart: chartObject.chart,
          keys: chartObject.chart.keys,
          usedKeys: chartObject.chart.usedKeys,
          authentication: chartObject.authentication,
          activeStep: 1,
        },
        () => {
          getChartData(
            chartObject,
            (resultData) =>
              this.setState({
                chart: { ...this.state.chart, data: resultData },
              }),
            (e) => console.error(e)
          );
          let codeVerifier = this.generateState();
          this.setState({
            authentication: {
              ...this.state.authentication,
              state: this.generateState(),
              codeVerifier,
              codeChallenge: window.btoa(ArcHash.sha256(codeVerifier)),
            },
          });
          this.handleChangeSubmitDisabled(true);
        }
      );
    } else {
      let codeVerifier = this.generateState();
      this.setState({
        authentication: {
          ...this.state.authentication,
          state: this.generateState(),
          codeVerifier,
          codeChallenge: window.btoa(ArcHash.sha256(codeVerifier)),
        },
      });
      this.handleChangeSubmitDisabled(true);
    }
  }
  handleAuthenticationChange = (authentication) => {
    let keys = [];
    let data = [];
    this.setState(
      authentication.radioChoice === this.state.authentication.radioChoice
        ? { authentication }
        : { authentication, keys, data }
    );
  };
  changeAvailableStep = (step) => {
    this.state.availableStep !== step && this.setState({ availableStep: step });
    if (step === 3 || this.state.chart.chartType === "Table") {
      this.state.availableStep !== step &&
        this.handleChangeSubmitDisabled(false);
    }
  };
  handleChangeSubmitDisabled = (submitDisabled) => {
    this.setState({ submitDisabled });
  };
  handleKeyChange = (keys) => {
    this.setState({ keys, usedKeys: keys });
  };
  handleDataChange = (data) => {
    this.setState({ data });
  };
  handleChartChange = (chart, callback) => {
    this.setState({ chart }, () => callback && callback());
  };
  handleOriginalDataChange = (originalData) => {
    this.setState({ originalData });
  };
  changeToken = (token) => {
    this.setState({ token });
  };
  setUsedKeys = (usedKeys) => {
    this.setState({ usedKeys });
  };
  setGroupByKey = (groupByKey) => {
    this.setState({ groupByKey: groupByKey });
  };
  setIncludeSummary = (includeSummary) => {
    this.setState({ includeSummary: includeSummary });
  };
  setIncludeSummaryChart = (includeSummaryChart) => {
    this.setState({ includeSummaryChart: includeSummaryChart });
  };
  changedUsedKey = (key, checked) => {
    let usedKeys = this.state.usedKeys.slice(0);
    let index = null;
    if (checked) {
      usedKeys.push(key);
    } else {
      index = usedKeys.indexOf(key);
      usedKeys.splice(index, 1);
    }
    this.setState({ usedKeys });
  };
  handleArrayChange = (array) => {
    this.setState({ array });
  };

  handleNext = () => {
    this.setState({ activeStep: this.state.activeStep + 1 });
  };
  handleBack = () => {
    this.setState({ activeStep: this.state.activeStep - 1 });
  };
  onSubmit = () => {
    let data = {};
    let chart = {
      ...this.state.chart,
      keys: this.state.keys,
      usedKeys: this.state.usedKeys,
      groupByKey: this.state.groupByKey,
      includeSummary: this.state.includeSummary,
      includeSummaryChart: this.state.includeSummaryChart,
    };
    data = { chart: chart, authentication: this.state.authentication };
    this.props.edit ? this.props.onSubmitEdit(data) : this.props.onSubmit(data);
  };
}
const mapStateToProps = (state) => ({
  apiLocation: state.setting.apiLocation,
});
export default connect(
  mapStateToProps,
  null
)(withTranslation()(ChartGeneratorDialog));
